module.exports = __webpack_public_path__ + "static/media/chevromRight.812df675.svg";